export const globalMessagesConstants = {
	ERROR: 'ERROR',
	SUCCESS: 'SUCCESS',
	CLEAR_MESSAGES: 'CLEAR_MESSAGES',
	HAS_CHANGES_TRUE: 'HAS_CHANGES_TRUE',
	HAS_CHANGES_FALSE: 'HAS_CHANGES_FALSE'
};
